<div class="app-body animated fadeIn background-default">
  <main class="main d-flex align-items-center">
    <div class="container ">
      <div class="row">
        <div class="col-md-8 mx-auto ">
          <div class="card-group ">
            <div class="card p-4 ">
              <div class="card-body ">
                <div class="alert alert-warning" role="alert" *ngIf="showNotConfigured()">
                  El sistema no cuenta con organizaciones y tiendas, inicie sesión sin seleccionar tienda para la
                  configuración automática.
                </div>
                <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="needs-validation">
                  <h1>Inicio de sesión</h1>
                  <p>Iniciar sesión con su cuenta</p>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fa fa-user"></i></span>
                    </div>
                    <input name="username" type="text" class="form-control" placeholder="Usuario"
                      autocomplete="username" formControlName="username"
                      [class.is-invalid]="(form.controls.username.touched || form.controls.username.dirty) && form.controls.username.invalid">
                    <div class="invalid-feedback ">
                      Seleccione un usuario
                    </div>
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fa fa-lock"></i></span>
                    </div>
                    <input name="password" type="password" class="form-control" placeholder="Contraseña"
                      autocomplete="current-password" formControlName="password"
                      [class.is-invalid]="(form.controls.password.touched || form.controls.password.dirty) && form.controls.password.invalid">
                    <div class="invalid-feedback ">
                      Ingrese una contraseña
                    </div>
                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text input-group-padding"><i
                          class="fa fa-regular fa-building"></i></span>
                    </div>
                    <select id="salesOrg" name="salesOrg" class="form-control" formControlName="salesOrg"
                      (change)="filterBranches()">
                      <option value="">Seleccione una Organización</option>
                      <option *ngFor="let salesOrg of salesOrgs" [value]="salesOrg.code">{{salesOrg.code}} -
                        {{salesOrg.name}}</option>
                    </select>

                  </div>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fa fa-home"></i></span>
                    </div>
                    <ng-select [items]="filteredBranches" formControlName="branch" [searchable]="true"
                      placeholder="Seleccione una tienda" [searchFn]="customSearchBranches" class="form-control">
                      <ng-template ng-label-tmp let-item="item">
                        {{item.code}}-{{item.name}}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.code}}-{{item.name}}">{{item.code}}-{{item.name}}</div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <pos-captcha name="captcha" id="captcha" formControlName="captcha" *ngIf="!hideCaptcha"
                    (getCaptchaId)="getCaptchaId($event)"></pos-captcha>
                  <!-- <div class="input-group mb-3">
                  </div> -->
                  <div class="row">
                    <div class="col-6">
                      <button type="submit" class="btn btn-outline-primary px-4">Login</button>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-6 text-right">
                      <button type="button" class="btn btn-link px-0" (click)="goToChangePassword()">Cambiar
                        contraseña</button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-right">
                      <button type="button" class="btn btn-link px-0" (click)="goToChangeForgetPassword()">Se me olvido
                        mi contraseña o mi usuario esta bloqueado</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="card py-5 d-md-down-none text-center bg-primary" style="width:44%">
              <div class="card-body">
                <div>
                  <img src="assets/logoILP.png" class="rounded img-fluid mb-3" alt="Responsive image">
                  <h4>Sistema de facturación POS</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>